import React from 'react';

import { contentTypes } from '../../common/Constants';
import SiteConstants from '../../common/SiteConstants/SiteConstants';

interface Props {
  contentType: string;
  className: string;
}

const SimilarClipsHeader: React.FC<Props> = ({
  contentType,
  className = '',
  children,
}) => {
  let categoryName = `Similar ${SiteConstants.getInstance().getStockItemName()}s`;

  if (contentType === contentTypes.FOOTAGE) {
    categoryName = 'Similar Footage';
  } else if (contentType === contentTypes.TEMPLATE) {
    categoryName = 'Similar Templates';
  } else if (contentType === contentTypes.MOTION_BG) {
    categoryName = 'Similar Backgrounds';
  }

  return (
    <div className="similar-stock-items">
      <h2 className={className}>{categoryName}</h2>
      {children}
    </div>
  );
};

export default SimilarClipsHeader;
